{
  "requestor": "Requestor",
  "permission": "Permission",
  "approvalLevel": "Approval Level",
  "approval": "Approval",
  "dropdown": {
    "viewRequest": "View Request",
    "viewUser": "View User",
    "resendWelcomeEmail": "Resend Welcome Email",
    "editPermissions": "Edit Permissions",
    "removeAccessToAllEntities": "Remove Access To All Entities",
    "approveRequest": "Approve Request",
    "rejectRequest": "Reject Request",
    "removeAccessToEntity": "Remove Access to Entity"
  },
  "entity": {
    "users": "Users ({{numberOfUsers}})",
    "usersSubtitle": "All the users granted access to this entity",
    "approvalConfiguration": "Approval Configuration",
    "approvalConfigChangeRequested": "Editing is unavailable until the existing change is reviewed.",
    "level": "Level",
    "amount": "Amount (£)",
    "range": "{{from}} to {{to}}",
    "umCode": "UM Code",
    "unlimited": "Unlimited",
    "pendingApprovalAlert": {
      "content": "An approval configuration change request has been made for this entity.",
      "title": "Configuration Approval Required",
      "reviewRequestButton": "Review Request"
    },
    "changeRequestDrawer": {
      "currentConfiguration": "Current Configuration",
      "proposedConfiguration": "Proposed Configuration",
      "changeRequestBy": "Change Requested by",
      "approveTooltip": "This request cannot be approved",
      "certaintyNote": "Before authorising this configuration change, please ensure that you are certain the permission set is correct.",
      "configurationChangedAlert": {
        "title": "This approval configuration no longer applies and cannot be approved.",
        "content": "The configuration has changed since this request was created, so it cannot be approved. Select Reject to dismiss it, then create a new change request."
      },
      "toast": {
        "approveSuccessTitle": "Approval Configuration Request Approved",
        "approveSuccessBody": "The new approval configuration has been successfully changed.",
        "rejectSuccessTitle": "Change Request Rejected",
        "rejectSuccessBody": "The approval configuration has not been changed.",
        "unableToApproveRequest": "Unable to approve change request",
        "unableToRejectRequest": "Unable to reject change request",

        "approveValidationFailed": "The proposed approval configuration is no longer valid. Please review the requested changes and try again.",
        "approveNotAuthorised": "You do not have permission to approve this change request.",
        "approveNotFound": "This change request could not be found. It may already have been resolved.",
        "approveNoLongerPending": "This change request is no longer pending and cannot be approved.",
        "approveConfigurationChanged": "The current configuration has changed since this request was created. The change request can no longer be approved.",

        "rejectNotAuthorised": "You do not have permission to reject this change request.",
        "rejectNotFound": "This change request could not be found. It may already have been resolved.",
        "rejectNoLongerPending": "This change request is no longer pending and cannot be rejected.",

        "requestActionNotCompleted": "The change request could not be processed. Please try again."
      }
    },
    "noApprovalConfiguration": {
      "title": "No approval configuration",
      "description": "If you would like to set up an approval configuration, please contact us.",
      "descriptionCanCreate": "If you would like to set up an approval configuration, please press the edit button."
    },
    "editApprovalConfig": {
      "button": {
        "enabled": "Edit",
        "disabled": "Learn More"
      },
      "editModal": {
        "title": {
          "edit": "Edit approval configuration",
          "learnMore": "How approval configuration works",
          "learnMoreIncorrectMode": "How approval configuration works"
        },
        "subtitle": {
          "edit": "Define the approval levels required for different payment amounts for this entity. All amounts are converted to GBP to determine the applicable approval level.",
          "learnMore": "Understand how payment approvals are set up and applied across your entities.",
          "learnMoreIncorrectMode": "Understand how payment approvals are set up and applied across your entities."
        },
        "infoAccordion": {
          "whatIs": {
            "title": "What is an approval configuration?",
            "paragraphs": [
              "Approval configurations are a key part of your payment security process. It defines who needs to approve a payment based on the payment amount."
            ]
          },
          "howDoBracketsWork": {
            "title": "How do payment amount brackets work?",
            "paragraphs": [
              "Payment amounts are grouped into brackets and each bracket has its own approval requirements.",
              "Typically, as the payment amount increases, the level of authorisation required also increases. Below is an example of how this can be set out:",
              "Approval levels follow a hierarchy, meaning a higher-level approval (A) can substitute for any lower-level approval (B or C).",
              "This helps to ensure that every payment is reviewed appropriately based on its value before it is processed."
            ]
          },
          "whoDoesItApplyTo": {
            "title": "Who does this apply to?",
            "paragraphs": [
              "This configuration applies to any user who approves payment requests.",
              "Approval levels are determined by your organisation, ensuring that the authorised users review payments based on the value of the payment."
            ]
          },
          "whatHappens": {
            "title": "What happens when configurations change?",
            "paragraphs": [
              "A change to the approval configuration must be approved by another user on the entity with Entity Manager permission before it takes effect; you cannot approve your own change. The updated configuration applies only to new payment requests created after approval. Payments already submitted for approval continue to follow the configuration that was active when they were input."
            ]
          }
        },
        "footer": {
          "gotIt": "Got it",
          "save": "Submit configuration",
          "cancel": "Cancel",
          "userConfirmation": "I understand that existing payments will use the previous approval configuration, while new payments will use the updated configuration. Individual user approval levels remain unchanged.",
          "tooltip": {
            "acknowledgement": "Please acknowledge statement above to save configuration",
            "incompleteConfig": "Please make sure all approval brackets have at least one approval level"
          }
        },
        "incorrectUserManagementModeAlert": {
          "title": "Manage entity approval settings",
          "body": "The approval settings for this entity are currently managed by Alpha. Contact Client Services to enable managing these settings in the portal."
        },
        "incompleteConfiguration": {
          "title": "Incomplete configuration",
          "body": "Please complete all required fields before saving."
        }
      },
      "toast": {
        "requestSubmitted": "Approval Configuration Changes Submitted",
        "requestAwaitingApproval": "The changes have been submitted for approval.",
        "unableToSubmitRequest": "Unable to submit change request",
        "requestNotSubmitted": "Your change request wasn’t submitted. Please try again.",
        "pendingRequestExists": "A change request for this entity is already awaiting approval.",
        "requestNotAuthorised": "You don’t have permission to request approval configuration changes for this entity.",
        "requestsNotEnabled": "This entity isn’t set up for approval configuration change requests. Contact Client Services to enable them.",
        "requestMatchesLiveConfig": "Your changes match the current configuration. Update at least one approval bracket before submitting.",
        "requestInvalid": "Some of your approval brackets aren’t valid. Please review them and try again."
      }
    },
    "approvalConfigBracketsTable": {
      "header": {
        "amount": "Amount range",
        "approvalLevel": "Approval level required"
      },
      "firstRange": {
        "amount": "£0 - £300,000",
        "approvalLevel": "C"
      },
      "secondRange": {
        "amount": "£300,000.01 - £1,000,000",
        "approvalLevel": "B"
      },
      "thirdRange": {
        "amount": "£1,000,000.01 - £3,000,000",
        "approvalLevel": "A + B"
      },
      "fourthRange": {
        "amount": "£3,000,000.01 - Unlimited",
        "approvalLevel": "A + A + A"
      }
    },
    "approvalConfigTable": {
      "header": {
        "fromAmount": "From amount (£)",
        "toAmount": "To amount (£)",
        "approvalLevel": "Approval level",
        "actions": "Actions"
      },
      "addRowBelow": "Add bracket below",
      "maxBrackets": "Maximum brackets reached ({{num}})",
      "deleteCurrentRow": "Delete bracket",
      "requiredMin": "Required minimum amount",
      "requiredMax": "Required maximum amount",
      "unlimited": "Unlimited"
    }
  },
  "entities": {
    "title": "Entities",
    "pendingApprovalAlert": {
      "title": "Approval configuration changes need review",
      "content": "One or more entities have pending approval configuration changes. Review them below to confirm or update."
    },
    "tabs": {
      "all": "All",
      "actionRequired": "Action Required"
    },
    "actionRequiredTable": {
      "viewApprovalRequest": "View Approval Request",
      "emptyState": {
        "title": "No entities require action",
        "description": "There are no actions pending. If you expected to see an entity here, check that you have permission to view or manage it."
      }
    },
    "viewEntity": "View Entity",
    "searchEntityName": "Search entity name",
    "table": {
      "entityName": "Entity name",
      "dropdown": {
        "addUserToEntity": "Add User To Entity"
      }
    }
  },
  "users": {
    "title": "Users",
    "buttons": {
      "createNewUser": "Create New User"
    },
    "tabs": {
      "approved": "Approved",
      "inReview": "In Review",
      "pendingApproval": "Pending Approval"
    },
    "searchPlaceholder": "Search name or username",
    "table": {
      "username": "Username",
      "status": "Status",
      "action": "Action"
    },
    "approvedTable": {
      "name": "Name"
    },
    "inReviewTable": {
      "description": "Description",
      "actionBy": "Action by",
      "requestDate": "Request date",
      "pendingApprovalTimebarNotice": {
        "title": "Approve requests within 90 days",
        "content": "Requests must be approved within 90 days of being created. If not, they'll be deleted and will need to be re-entered."
      },
      "tooltip": {
        "actionBy": "Requests not actioned within 90 days of creation will be deleted and will need to be re-entered."
      }
    },
    "user": {
      "addAccessButton": "Add access to entity",
      "noIdError": {
        "title": "User not found",
        "body": "Unable to retrieve this user's information. Please contact Client Services if you need support."
      },
      "userDropdown": {
        "remove": "Remove access to all entities",
        "resend": "Resend Welcome Email",
        "clone": "Clone user"
      },
      "detailsCard": {
        "title": "Details",
        "editButton": "Edit",
        "firstName": "First name",
        "lastName": "Last name",
        "mobile": "Mobile",
        "username": "Username",
        "lastUpdated": "Last Updated",
        "approveBy": "Approve by"
      },
      "entityTable": {
        "title": "Entities",
        "description": "All the entities {{name}} has access to",
        "columns": {
          "name": "Name",
          "permissions": "Permissions",
          "approvalLevel": "Approval Level"
        },
        "dropdown": {
          "remove": "Remove access to entity",
          "edit": "Edit Permissions"
        }
      },
      "requestTable": {
        "title": "Open Requests ({{requests}})",
        "columns": {
          "description": "Description",
          "requestDate": "Request date",
          "requestor": "Requestor",
          "actionBy": "Action by"
        },
        "requestStatus": {
          "pending": "Pending",
          "review": "In review"
        },
        "dropdown": {
          "viewUser": "View User",
          "viewRequest": "View Request",
          "approve": "Approve Request",
          "reject": "Reject Request"
        }
      }
    }
  },
  "permissionRequestDrawer": {
    "permissionChange": "Permissions Edit",
    "newUser": "New User Created",
    "accessRemoved": "Access Removal",
    "removingAccessTo": "Removing access to",
    "permissionTable": {
      "permissionChange": "Existing",
      "newUser": "Selected",
      "newRoles": "New"
    },
    "pendingApprovalTimebarNotice": "This request will be deleted on {{actionBy}} if not actioned, and will need to be re-entered"
  },
  "requestedRoleDescription": {
    "permissionChange": "Permissions amended for <1>{{entity}}</1>",
    "newUser": "New user created for <1>{{entity}}</1>",
    "accessRemoved": "User access removed for <1>{{entity}}</1>"
  },
  "groups": {
    "general": {
      "dropdown": {
        "view": "View group",
        "delete": "Delete group",
        "edit": "Edit group name"
      },
      "columns": {
        "groupName": "Group name",
        "numOfEntities": "Number of entities",
        "action": "Action"
      },
      "deleteModal": {
        "title": "Are you sure you want to delete {{groupName}}?",
        "description": "This group will be permanently deleted. This action cannot be undone.",
        "deleteButton": "Yes, delete",
        "groupIdError": "No Group ID found for {{groupName}}.",
        "generalError": "An error occurred while trying to delete this group.",
        "success": "Group deleted successfully."
      },
      "title": "Groups",
      "description": "Create groups to better organise your entities",
      "createButton": "Create new group",
      "search": "Search group name",
      "createNewGroupModal": {
        "title": "Create New Group",
        "actionButton": "Create Group",
        "nameField": {
          "label": "Group name",
          "placeholder": "Enter your new group name",
          "unique": "A group with name '{{name}}' already exists"
        },
        "entitiesField": {
          "label": "Select Entities",
          "subLabel": "Please note: Maximum of {{numberOfEntities}} entities per group",
          "placeholder": "Select entities",
          "noOptions": "No entities found",
          "minLength": "At least {{min}} entity must be selected",
          "maxLength": "No more than {{max}} entities can be selected"
        },
        "successSnackbar": "Group successfully created"
      },
      "addEntityToGroupModal": {
        "title": "Add entities to {{name}}",
        "actionButton": "Add entities",
        "entitiesField": {
          "label": "Select Entities",
          "subLabel": "Please note: Maximum of {{numberOfEntities}} entities per group",
          "placeholder": "Select entities",
          "noOptions": "No entities found",
          "minLength": "At least {{min}} entity must be selected",
          "maxLength": "Max number of entities({{max}}) has been met for this group, please remove entities to continue"
        },
        "successSnackbar": "Entities successfully added to group"
      },
      "editGroupModal": {
        "title": "Edit Group name",
        "nameField": {
          "label": "Group name",
          "placeholder": "Enter your new group name",
          "unique": "A group with name '{{name}}' already exists",
          "sameAsCurrent": "The new group name must be different from the current name '{{name}}'"
        },
        "successSnackbar": "Group successfully updated"
      }
    },
    "single": {
      "crumb": "View Group",
      "dropdown": {
        "remove": "Remove entity from group"
      },
      "columns": {
        "entities": "Entities"
      },
      "addButton": "Add entity to group",
      "search": "Search entity name",
      "noIdError": "No group ID found.",
      "noMatchingIdError": "No entity group with matching ID found.",
      "deleteEntity": {
        "loading": "Removing entity from group",
        "success": "Entity deleted from group successfully.",
        "noIdError": "Could not delete entity from group. No entity or group found.",
        "error": "An error occurred while trying to delete entity from group."
      }
    }
  },
  "entityAccess": {
    "crumb": "Entity access",
    "flowTitle": "Entity access",
    "entities": {
      "title": "Entities",
      "subtitle": "Please select the entities where you want to add this user or edit their permissions."
    },
    "permissions": {
      "title": "Permissions",
      "subtitleMulti": "This individual is being created for multiple entities. Please select the permissions you would like to grant them.",
      "subtitle": "Please select the permission you would like to grant them.",
      "components": {
        "ChangesRequired": {
          "message": "Changes required"
        }
      }
    },
    "summary": {
      "title": "Summary",
      "subtitle": "Please review the below details before submitting user."
    }
  },
  "create": {
    "crumb": "Create new user",
    "flowTitle": "New User",
    "userDetails": {
      "title": "User Details",
      "subtitle": "Firstly, please provide the details for the user you are creating.",
      "fields": {
        "firstName": {
          "label": "First name",
          "placeholder": "Please enter your first name"
        },
        "lastName": {
          "label": "Last name",
          "placeholder": "Please enter your last name"
        },
        "mobile": {
          "label": "Mobile phone number",
          "placeholder": "Please enter your mobile phone number",
          "description": "This number is used for Strong Customer Authentication"
        },
        "email": {
          "label": "Email",
          "placeholder": "Please enter your email",
          "description": "This will be their username to login to the Alpha platform"
        }
      }
    },
    "entities": {
      "title": "Entities",
      "subtitle": "Next, please select the entities you want to add this user to.",
      "fields": {
        "entities": {
          "label": "Entities",
          "placeholder": "Select your entities",
          "description": "Please note, you can only select up to 20 entities max, per approval request"
        }
      },
      "dataError": "Error loading entities"
    },
    "permissions": {
      "title": "Permissions",
      "subtitle": "Please select the permission you would like to grant them.",
      "subtitleMulti": "This individual is being created for multiple entities. Please select the permissions you would like to grant them.",
      "fields": {
        "beneficiary": {
          "label": "Beneficiaries"
        },
        "payments": {
          "label": "Payments"
        },
        "iat": {
          "label": "Transfers"
        },
        "other": {
          "label": "Other"
        },
        "approvalLevel": {
          "label": "Approval level",
          "placeholder": "Select level"
        }
      },
      "alerts": {
        "viewOnlyReporting": "View only/Reporting permissions are applied by default for each entity.",
        "missingApprovalConfig": "The approval configuration for this entity was not set. Please contact customer support.",
        "requiresApproval": "Please note that this request will require review and may require additional documentation before being enabled. Until then {{firstName}} {{lastName}} will be provided read only/inputter access for {{entityName}}."
      },
      "table": {
        "entities": "Entities",
        "permissions": "Permissions",
        "viewApprovalStructure": "View approval structure",
        "viewApprovalStructureModalTitle": "Approval Structure",
        "approvalLevel": "Approval level",
        "amount": "Amount"
      },
      "components": {
        "ClearAll": {
          "title": "Are you sure you want to clear?",
          "description": "Any information inputted will not be stored."
        },
        "RevertAll": {
          "title": "Are you sure you want to revert?",
          "description": "Any information inputted will not be stored."
        },
        "CopyPermissions": {
          "alert": {
            "title": "Please note",
            "content": "Only permissions will be copied. If applicable, the approval level will be left empty and must be set individually for each entity."
          },
          "modal": {
            "title": "Apply to other entities"
          },
          "toast": {
            "title_one": "Permissions applied to {{count}} entity",
            "title_other": "Permissions applied to {{count}} entities",
            "body": "Please manually apply approval levels."
          }
        }
      }
    },
    "summary": {
      "title": "Summary",
      "subtitle": "Please review the below details before submitting user",
      "submitSuccess": "User successfully created.",
      "editSuccess": "Request submitted for approval.",
      "submitGenericError": "We were unable to create the user. Please contact customer support.",
      "editGenericError": "We were unable to submit for approval. Please contact customer support."
    },
    "buttons": {
      "submitUser": "Submit user"
    },
    "validation": {
      "required": "This field is required",
      "maximumSelections": "You can only select {{maxSelections}} entities per approval request. Please remove some before continuing",
      "maximumChars": "Must be {{numOfChars}} characters or less",
      "minimumChars": "Must be {{numOfChars}} characters or more",
      "invalidMobilePhoneNumber": "Mobile phone number format is invalid",
      "invalidEmail": "Please enter a valid email address",
      "userExists": "User already exists",
      "invalidFormat": "Invalid format. Only letters, spaces, apostrophes, hyphens, and periods are allowed.",
      "alert": {
        "title": "Looks like <1>{{firstName}}</1> <2>{{lastName}}</2> already exists",
        "content": "This user has already been set up on the system. What would you like to do?",
        "buttons": {
          "editPermissions": "Edit permissions",
          "viewUser": "View user"
        }
      },
      "mobileAlert": {
        "inUseBy": "This number is already registered to <name>{{name}}</name>. ",
        "inUseByWithOthers_one": "This number is already registered to <name>{{name}}</name> and <count>{{count}} other user</count>. ",
        "inUseByWithOthers_other": "This number is already registered to <name>{{name}}</name> and <count>{{count}} other users</count>. ",
        "description": "If the account(s) associated with this number are no longer in use, contact client services at <link/> to deactivate them. ",
        "belongsTo": "This number already belongs to <name>{{name}}</name>",
        "viewUser": "View User"
      },
      "mobileErrorAlert": {
        "message": "An unexpected error occurred. If this issue continues, please contact our Client Services team at <link/> for assistance."
      }
    }
  },
  "permissionGlossary": {
    "title": "Permission Glossary",
    "table": {
      "title": "Permission",
      "description": "Description"
    },
    "tabs": {
      "all": "All",
      "payments": "Payments",
      "beneficiary": "Beneficiaries",
      "iat": "Transfers",
      "entities": "Entities",
      "other": "Other"
    },
    "permissions": {
      "group": {
        "Read Only / Reporting": "Read Only / Reporting",
        "Beneficiary": "Beneficiaries",
        "IAT": "Transfers",
        "Other": "Other",
        "Payments": "Payments",
        "Entities": "Entities"
      },
      "label": {
        "Read Only / Reporting": "Read Only / Reporting",
        "Payments Inputter": "Payments Inputter",
        "Payments Approver": "Payments Approver",
        "Payments Approver Own": "Payments Approver Own",
        "Beneficiary Inputter": "Beneficiary Inputter",
        "Beneficiary Approver": "Beneficiary Approver",
        "Beneficiary Approver Own": "Beneficiary Approver Own",
        "IAT Inputter": "Transfers Inputter",
        "IAT Approver": "Transfers Approver",
        "IAT Approver Own": "Transfers Approver Own",
        "Entity Viewer": "Entity Viewer",
        "Entity Manager Add All Perms": "Entity Manager Add All Perms",
        "Invoice Manager": "Invoice Manager",
        "FX Booker": "FX Booker",
        "Onboarder": "Onboarder"
      },
      "level": {
        "Inputter": "Inputter",
        "Approver": "Approver",
        "Approver Own": "Approver own",
        "Viewer": "Entity Viewer",
        "Invoice Manager": "Invoice Manager",
        "FX Booker": "FX Booker"
      },
      "description": {
        "A Read Only/Reporting role allows a user to view information such as payments, beneficiaries and transactions across the platform.": "A Read Only/Reporting role allows a user to view information such as payments, beneficiaries and transactions across the platform.",
        "A Payments Inputter is a user that can input same currency and cross currency payments.": "A Payments Inputter is a user that can input same currency and cross currency payments.",
        "A Payments Approver is a user that can approve same currency and cross currency payments.": "A Payments Approver is a user that can approve same currency and cross currency payments.",
        "A Payments Approver Own is a user that can approver their own payment. For example, if a Payments Approver Own inputs a payment where 2 approvals are required, only one additional approval will be needed.": "A Payments Approver Own is a user that can approve their own payment. For example, if a Payments Approver Own inputs a payment where 2 approvals are required, only one additional approval will be needed.",
        "A Beneficiary Inputter role allows a user to create a beneficiary for approval.": "A Beneficiary Inputter role allows a user to create a beneficiary for approval.",
        "A Beneficiary Approver is a user that can approve a beneficiary.": "A Beneficiary Approver is a user that can approve a beneficiary.",
        "A Beneficiary Approver Own is a user that can approve their own beneficiary creation. For example, if a Beneficiary Approver Own inputs a beneficiary where 2 approvals are required, only one additional approval will be needed.": "A Beneficiary Approver Own is a user that can approve their own beneficiary creation. For example, if a Beneficiary Approver Own inputs a beneficiary where 2 approvals are required, only one additional approval will be needed.",
        "An IAT Inputter is a user that can input inter-account transfers between two accounts that belong to the same entity.": "A Transfers Inputter is a user that can input inter-account transfers between two accounts that belong to the same entity.",
        "An IAT Approver is a user that can approve inter account transfers between two accounts that belong to the same entity.": "A Transfers Approver is a user that can approve inter account transfers between two accounts that belong to the same entity.",
        "An IAT Approver Own is a user that can approver their own transfer. For example, if an IAT Approver Own inputs a transfer where 2 approvals are required, only one additional approval will be needed.": "A Transfers Approver Own is a user that can approve their own transfer. For example, if a Transfers Approver Own inputs a transfer where 2 approvals are required, only one additional approval will be needed.",
        "An Entity Viewer is a user that can see who has access to the entities they can see on the portal, and what permissions they have.": "An Entity Viewer is a user that can see who has access to the entities they can see on the portal, and what permissions they have.",
        "An Entity Manager is a user that can add, edit and delete other users and their permissions on the platform.": "An Entity Manager is a user that can add, edit and delete other users and their permissions on the platform.",
        "An Invoice Manager is a user that can view invoices on the platform.": "An Invoice Manager is a user that can view invoices on the platform.",
        "An FX Booker is a user that can book FX for cross currency payments and inter-account transfers.": "An FX Booker is a user that can book FX for cross currency payments and inter-account transfers.",
        "An Onboarding Manager is a user that can onboard new entities.": "An Onboarding Manager is a user that can onboard new entities."
      }
    }
  },
  "modal": {
    "rejectPermissions": {
      "title": "Are you sure you wish to reject this request?",
      "titleMulti": "Are you sure you would like to reject all the selected requests?",
      "content": "This request will be rejected permanently. This action cannot be undone.",
      "contentMulti": "These requests will be rejected permanently. This action cannot be undone.",
      "success": "Successfully rejected permission change request",
      "successMulti": "Successfully rejected permission change requests",
      "error": "There was an error rejecting this request",
      "errorMulti": "There was an error rejecting these requests",
      "errorPleaseRetryTitle": "Unable to reject the user.",
      "errorPleaseRetryBody": "The user may have already been rejected. Please check their status and try again.",
      "buttons": {
        "cancel": "Cancel",
        "confirm": "Yes, reject"
      }
    },
    "removeAccess": {
      "content": "Entity that access will be removed for",
      "contentAll": "Entities that access will be removed for",
      "removeAll": "Are you sure you want to remove access to all entities?",
      "remove": "Are you sure you want to remove this user's access?",
      "removeAllWarningTitle": "Please note",
      "removeAllWarningContent": "If this user has access to any other entities not managed by you, then they will still have access to those entities.",
      "success": "Successfully submitted a remove access request",
      "error": "An unexpected error occurred. If this issue continues, please contact our Client Services team for assistance.",
      "buttons": {
        "cancel": "Cancel",
        "confirm": "Yes, remove"
      },
      "dataError": "Unable to retrieve this user's information. Please contact Client Services if you need support."
    },
    "removeFromEdit": {
      "title": "Are you sure you want to remove this entity?",
      "content": "This will remove the entity and no changes will be saved."
    }
  },
  "approvePermissions": {
    "errors": {
      "unauthenticatedApiCall": "An unexpected error occurred. If this issue continues, please contact our Client Services team for assistance.",
      "errorPleaseRetryTitle": "Unable to approve the user.",
      "errorPleaseRetryBody": "The user may have already been approved. Please check their status and try again."
    },
    "success": {
      "successfullyApproved": "Successfully approved user role request",
      "successfullyApprovedMulti": "Successfully approved user role requests"
    }
  },
  "bulkPendingRequestDropdown": {
    "selected": "Selected",
    "approve": "Approve",
    "reject": "Reject",
    "approvalTooltip": "You don’t have approval permission for ({{count}}) request",
    "approvalTooltipMulti": "You don’t have approval permission for ({{count}}) requests",
    "rejectTooltip": "You don’t have reject permission for ({{count}}) request",
    "rejectTooltipMulti": "You don’t have reject permission for ({{count}}) requests"
  },
  "resendWelcomeEmail": {
    "inProgress": "Re-sending Welcome email",
    "success": "Welcome email successfully re-sent",
    "tooManyAttempts": "Please wait 5 minutes before trying to send again",
    "forgotPassword": "Unable to resend the welcome email, please ask the user to try using the forgot password form if they are unable to log in.",
    "genericError": "There was an issue resending the welcome email. If this problem persists please contact customer support."
  },
  "conflictingRequests": {
    "title": "Conflicting permission requests",
    "pendingPermissionRequest": "A permissions change request exists for this user on one or more of the entities selected. You cannot submit a new request for the user on this entity until the current one is approved or rejected.",
    "selectedConflict": "One or more users have multiple permission change requests for the same entity. You can only action one of these requests at a time.",
    "errorMessage": "Permission request already exists on one or more entities",
    "chipContent": "Existing Request"
  }
}
